import { css } from "styled-system/css";

import { Tag } from "../tag";

const newBadgeOverrides = css({
  ml: "8",
  letterSpacing: "[0.05em]",
  textTransform: "uppercase",
});

export function NewBadge({ label }: { label: string }) {
  return (
    <Tag variant="secondary" className={newBadgeOverrides}>
      {label}
    </Tag>
  );
}
